module.exports = __webpack_public_path__ + "static/share-card-2820077e3921806ee6c5e6c06b51e1e2.png";